import wrapError from "@/components/helpers/wrapError"

export const apiUpdateSynonyms = (params, success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/internal/synonymManager",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(params),
    success,
    error: wrapError(error, "apiUpdateSynonyms"),
  })
}

export const apiFetchSynonyms = (success, error) => {
  $.ajax({
    type: "GET",
    url: "/api/internal/synonymManager",
    success,
    error: wrapError(error, "apiFetchSynonyms"),
  })
}
